// Responsive Dashboard.jsx with Sidebar + Tabs + Mobile Support

import React, { useState,useEffect } from "react";
import { useAuth } from "./lib/AuthContext";
import Calendar from "./Calendar";
import Notes from "./Notes";
import { Button } from "./components/ui/button";
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from "./components/ui/tabs";
import { Card, CardContent } from "./components/ui/card";
import { Avatar, AvatarFallback } from "./components/ui/avatar";



const Dashboard = () => {
  const { user, logout } = useAuth();
  const [activeTab, setActiveTab] = useState("calendar");

  const triggerStyle = (value) =>
    `justify-start px-4 py-2 text-left rounded-md hover:bg-gray-100 transition ${
      activeTab === value ? "bg-indigo-100 text-indigo-700 font-semibold" : ""
    }`;
    useEffect(() => {
  console.log("🔥 ClientDashboard is the one rendering!");
}, []);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col md:flex-row">

      {/* Sidebar */}
      <div className="w-full md:w-72 bg-white shadow-xl border-r rounded-none md:rounded-r-xl p-4 md:p-6 flex flex-col h-full">
        <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 mb-6">
          <Avatar>
            <AvatarFallback>
              {user?.username?.slice(0, 2).toUpperCase()}
            </AvatarFallback>
          </Avatar>
          <div>
            <p className="text-base sm:text-lg font-semibold text-gray-800">{user?.username}</p>
            <p className="text-sm text-gray-500 capitalize">{user?.role}</p>
          </div>
        </div>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="flex-1">
          <TabsList className="flex flex-wrap md:flex-col gap-2 overflow-x-auto">
            <TabsTrigger value="calendar" className={triggerStyle("calendar")}>📅 Schedule</TabsTrigger>
            <TabsTrigger value="notes" className={triggerStyle("notes")}>📝 Notes</TabsTrigger>
            <TabsTrigger value="intake" className={triggerStyle("intake")}>📁 Intake Form</TabsTrigger>
            <TabsTrigger value="profile" className={triggerStyle("profile")}>⚙ Profile</TabsTrigger>
          </TabsList>
        </Tabs>

        <div className="mt-6 md:mt-auto pt-4">
          <Button
            variant="destructive"
            className="w-full bg-red-600 hover:bg-red-700 text-white text-sm py-2"
            onClick={logout}
          >
            🚪 Logout
          </Button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 p-4 sm:p-6 md:p-10">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsContent value="calendar">
            <div className="mb-6">
              <h1 className="text-xl sm:text-2xl font-semibold text-gray-800">
                Welcome, {user?.username}
              </h1>
              <p className="text-sm text-gray-500">Here’s your upcoming schedule.</p>
            </div>
            <Card className="shadow-md border rounded-xl bg-white">
              <CardContent className="p-4 sm:p-6">
                <Calendar />
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="notes">
            <Card className="shadow-sm border rounded-xl bg-white">
              <CardContent className="p-4 sm:p-6">
                <Notes />
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="intake">
            <Card className="shadow-sm border rounded-xl bg-white">
              <CardContent className="p-4 sm:p-6">
                {user?.role === "client" ? (
                  <div>
                    <p className="mb-2 text-gray-700">Download your intake form:</p>
                    <a
                      href="/static/intake-form.pdf"
                      className="text-blue-600 underline hover:text-blue-800"
                      download
                    >
                      Intake Form (PDF)
                    </a>
                  </div>
                ) : (
                  <p className="text-sm text-gray-600">
                    Therapist Upload Portal coming soon.
                  </p>
                )}
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="profile">
            <Card className="shadow-sm border rounded-xl bg-white">
              <CardContent className="p-4 sm:p-6 space-y-2 text-gray-800">
                <div>
                  <strong>Username:</strong> {user?.username}
                </div>
                <div>
                  <strong>Role:</strong> {user?.role}
                </div>
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default Dashboard;
